import { WeatherConditions } from "common";
import { useTranslation } from "react-i18next";
import { Text, TextProps } from "tamagui";

export interface WeatherConditionsProps extends TextProps {
  conditions: WeatherConditions;
}

export const WeatherConditionsText = ({
  conditions,
  ...rest
}: WeatherConditionsProps) => {
  const { t } = useTranslation();
  const key = mapConditionToKey(conditions);

  return <Text {...rest}>{t(`weather.conditions.${key}`)}</Text>;
};

const mapConditionToKey = (conditions: WeatherConditions) => {
  switch (conditions) {
    case WeatherConditions.Blizzard:
      return "blizzard";
    case WeatherConditions.BlowingSand:
      return "blowingSand";
    case WeatherConditions.Cloudy:
      return "cloudy";
    case WeatherConditions.Dry:
      return "dry";
    case WeatherConditions.Foggy:
      return "foggy";
    case WeatherConditions.FullMoon:
      return "fullMoon";
    case WeatherConditions.Hail:
      return "hail";
    case WeatherConditions.HeavyRain:
      return "heavyRain";
    case WeatherConditions.HeavyRainstorm:
      return "heavyRainstorm";
    case WeatherConditions.LightRain:
      return "lightRain";
    case WeatherConditions.Lighting:
      return "lighting";
    case WeatherConditions.Mist:
      return "mist";
    case WeatherConditions.ModerateSnow:
      return "moderateSnow";
    case WeatherConditions.MoonCloudy:
      return "moonCloudy";
    case WeatherConditions.PartlyCloudyDaytime:
      return "partlyCloudyDaytime";
    case WeatherConditions.PartlyCloudyNight:
      return "partlyCloudyNight";
    case WeatherConditions.Rainbow:
      return "rainbow";
    case WeatherConditions.Sandstorm:
      return "sandstorm";
    case WeatherConditions.Snowy:
      return "snowy";
    case WeatherConditions.SunCloudy:
      return "sunCloudy";
    case WeatherConditions.Sunny:
      return "sunny";
    case WeatherConditions.Thunderstorm:
      return "thunderstorm";
    case WeatherConditions.Typhoon:
      return "typhoon";
    case WeatherConditions.Wet:
      return "wet";
    default:
      return "unknown";
  }
};
